"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function () {
        return api_base_1.default.get("/report_definitions").then(function (data) { return data.data.data; });
    }
};
//# sourceMappingURL=report_definitions.js.map